import { render, staticRenderFns } from "./News.vue?vue&type=template&id=3e495bd6&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"
import style0 from "./scss/news.scss?vue&type=style&index=0&id=3e495bd6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e495bd6",
  null
  
)

export default component.exports